import api from 'api'
import { CACHE_TAG_ACCOUNTS_VERSION_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    activateAccount: build.mutation({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/activate/${accountId}`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, { accountId }) => [{ type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: accountId }],
    }),
  }),
})

export const { useActivateAccountMutation } = extendedApi
